import $ from 'jquery';
import BaseComponent from 'components/BaseComponent';

export default class JumpToComponent extends BaseComponent {
    constructor($element, options) {
        super($element, options);

        this.init();
    }

    static defaults = {
    }

    SELECTOR = {
        CONTROL: '[data-jump-control]',
    }

    /**
     * Binds the scope of any handler functions.
     * Should only be run on initialization of the view.
     *
     * @method setupHandlers
     * @returns {JumpToComponent}
     * @private
     */
    setupHandlers() {
        // Bind event handlers scope here
        this.onChangeHandler = this.onChange.bind(this);

        return this;
    }

    /**
     * Create any child objects or references to DOM elements.
     * Should only be run on initialization of the view.
     *
     * @method createChildren
     * @returns {JumpToComponent}
     * @private
     */
    createChildren() {
        super.createChildren();

        this.$control = this.$element.find(this.SELECTOR.CONTROL);

        return this;
    }

    /**
     * Remove any child objects or references to DOM elements.
     *
     * @method removeChildren
     * @returns {JumpToComponent}
     * @public
     */
    removeChildren() {
        super.removeChildren();

        return this;
    }

    /**
     * Enables the component.
     * Performs any event binding to handlers.
     * Exits early if it is already enabled.
     *
     * @method enable
     * @returns {JumpToComponent}
     * @public
     */
    enable() {
        if (this.isEnabled) {
            return this;
        }
        this.isEnabled = true;

        this.$control.on('change', this.onChangeHandler);

        return this;
    }

    /**
     * Disables the component.
     * Tears down any event binding to handlers.
     * Exits early if it is already disabled.
     *
     * @method disable
     * @returns {JumpToComponent}
     * @public
     */
    disable() {
        if (!this.isEnabled) {
            return this;
        }
        this.isEnabled = false;


        return this;
    }

    /*
        EVENT HANDLERS
    */
    onChange(e) {
        const location = $(e.currentTarget).val();
        this.jumpToLocation(location);
    }

    /**
     * Goes to location passed in.
     *
     * @method hideNotification
     * @public
     * @param {String} location
     */
    jumpToLocation(location) {
        window.location.href = location;
    }
}
